import React from 'react'
import ReactDOM from 'react-dom/client'
import { PostHogProvider } from '@posthog/react'
import { App } from './App'
import { logHostedBackendUrlOnStartup } from './config/hostedBackendUrl'
import { logWebUiDevBanner } from './logging/webLog'

document.title = 'Owlbert'
logHostedBackendUrlOnStartup()
logWebUiDevBanner()

const posthogOptions = {
  api_host: import.meta.env.POSTHOG_HOST as string,
  defaults: '2026-01-30',
  // Don't send events during local dev unless explicitly opted in
  loaded: (ph: { opt_out_capturing: () => void }) => {
    if (import.meta.env.DEV && !import.meta.env.VITE_POSTHOG_ENABLE_DEV) {
      ph.opt_out_capturing()
    }
  },
} as const

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={import.meta.env.POSTHOG_PROJECT_TOKEN as string}
      options={posthogOptions}
    >
      <App />
    </PostHogProvider>
  </React.StrictMode>,
)
